module.exports = __webpack_public_path__ + "img/cofing_cotizacion.e8e3b040.png";